import { useEffect } from 'react'

const Events = ({ funcao, eventos, setEvento, limparVeiculoEscolhido }) => {
  const onClickEvent = (evento) => {
      console.log("evento = ", evento);
      setEvento(evento);
      limparVeiculoEscolhido(null);
  }

  useEffect(() => {
    console.log("Eventos recebidos = ", eventos);
  },[]);

  return (
    <div className="devices">
      <button onClick={() => funcao(2)}>Voltar</button>
      <h2>Eventos deste campo</h2>
      {eventos.map(( evento ) => (
        <div className="devices-preview" key={evento.eventoUUID}>
          <h3>{evento.eventoNome}</h3>
          <p>Área aplicada Total = {evento.areaAplicadaTotal} ha</p>
          <button onClick={() => onClickEvent(evento)}>Ver detalhe</button>
        </div>
      ))}
    </div>
  )
}

export default Events;
/**/